import { render, staticRenderFns } from "./FiltersProfile.vue?vue&type=template&id=6f24e584&scoped=true&"
import script from "./FiltersProfile.vue?vue&type=script&lang=js&"
export * from "./FiltersProfile.vue?vue&type=script&lang=js&"
import style0 from "./FiltersProfile.vue?vue&type=style&index=0&id=6f24e584&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f24e584",
  null
  
)

export default component.exports